export default "__VITE_ASSET__CEr_8WJM__"